/**
 * new version of zg-notifier
 */

(function toastHandler(){

	const error_serverside_toggle = '.error-serverside';
	const alert_toggle            = '.alert';

	let TOAST_CONTAINER = document.createElement('div');
	let containerClasses = ['toast-container','position-fixed','bottom-0','end-0','p-3'];
	TOAST_CONTAINER.classList.add(...containerClasses);
	document.body.appendChild(TOAST_CONTAINER);

	class Notification {
		constructor(eventType, message) {
			this.eventType = eventType;
			this.message =   message;
		}
	}

	function create_toast(params) {
		let toastEl =
			`<div class="toast ${params.class_name}" role="alert" aria-live="assertive" aria-atomic="true" data-is-toast="true">
			  <div class="toast-header">
				<strong class="me-auto">${params.title}</strong>
				<button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
			  </div>
			  <div class="toast-body">
				${params.text}
			  </div>
   			 </div>`;
		//appending so you can stack the toasts
		TOAST_CONTAINER.innerHTML += toastEl; //appending so you can stack the toasts
		const toastElList = document.querySelectorAll('[data-is-toast="true"]');
		const toastList = [...toastElList].map(function (toastEl) {
			let el = new bootstrap.Toast(toastEl);
			el.show();
			toastEl.addEventListener('hidden.bs.toast', () => {
				toastEl.remove();
			})
		}) ;
	}

	function trigger_toast(type, notif){
		let notificationType = type;
		let notificationClone = {...notif};
		if (notificationType === 'danger'){
			create_toast({
				title:      window.JS_TRANSLATIONS['notifier.error'] || 'Error',
				text:       notificationClone.message.textContent.trim(),
				class_name: 'text-bg-danger',
			});
		} else if (notificationType === 'waning'){
			create_toast({
				title:      window.JS_TRANSLATIONS['notifier.warning'] || 'Warning',
				text:       notificationClone.message.textContent.trim(),
				class_name: 'text-bg-warning',
			}) ;
		} else if (notificationType === 'success'){
			create_toast({
				title:      window.JS_TRANSLATIONS['notifier.notification'] || 'Notification',
				text:       notificationClone.message.textContent.trim(),
				class_name: 'text-bg-success',
			}) ;
		}
	}
	//Show alert located in master template only when manager is secure
	if(SGL_JS_MANAGER === 'secure') {
		const errorElList = document.querySelectorAll(error_serverside_toggle);
		const errorList = [...errorElList].map(errorEl =>{
			let alertElList = errorEl.querySelectorAll(alert_toggle);
			let alertList = [...alertElList].map(alertEl =>{
				//here reads the message
			});
		});
	}

	function notifyByTrigger( event, notification ){
		if ( notification.message && typeof notification.message === 'string' && SGL_JS_MANAGER === 'secure' ) {
			if (event.type == "zg-notification") {
				create_toast({
					title: window.JS_TRANSLATIONS['notifier.notification'] || 'Notification',
					text: notification.message,
					class_name: 'text-bg-success',
				});
			}
			if (event.type == "zg-error") {
				create_toast({
					title: window.JS_TRANSLATIONS['notifier.error'] || 'Error',
					text: notification.message,
					class_name: 'text-bg-danger',
				});
			}
			if (event.type == "zg-warning") {
				create_toast({
					title: window.JS_TRANSLATIONS['notifier.warning'] || 'Warning',
					text: notification.message,
					class_name: 'text-bg-warning',
				});
			}
		}
	}



})();